import { useEffect, useState } from 'react';
import { Box, Card, CardContent, Typography } from '@mui/material';

import {
  Chart as ChartJS,
  ArcElement,
  Tooltip,
  Legend
} from 'chart.js';

import { IRoleInterface, RoleService } from '../../shared/services/api/roles/RoleService';
import { FerramentasDaListagem } from '../../shared/components';
import { LayoutBaseDePagina } from '../../shared/layouts';

// Registre os elementos necessários para o Pie Chart
ChartJS.register(ArcElement, Tooltip, Legend);

export const Dashboard = () => {
  const [isLoadingProcessing, setIsLoadingProcessing] = useState(true);

  const [userRoles, setUserRoles] = useState<IRoleInterface | null>(null);

  // Busca o processamento do usuário
  useEffect(() => {
    setIsLoadingProcessing(true);
    RoleService.getRoles()
      .then((result) => {
        setIsLoadingProcessing(false);

        if (result instanceof Error) {
          alert(result.message);
        } else {
          setUserRoles(result);
        }
      });
  }, []);


  return (
    <LayoutBaseDePagina
      titulo="Usuário"
      barraDeFerramentas={<FerramentasDaListagem mostrarBotaoNovo={false} />}
    >
      <Box width="100%" display="flex" flexDirection="column" alignItems="center" margin={2}>

        {/* Card de Processamento do Usuário */}
        <Card sx={{ width: '100%', maxWidth: 600 }}>
          <CardContent>
            <Typography variant="h5" align="center">
              Processamento do Usuário
            </Typography>

            <Box padding={2} display="flex" flexDirection="column" alignItems="center">
              {!isLoadingProcessing && userRoles && (
                <>
                  <Typography variant="body1">
                    <strong>Processamento Total:</strong> {userRoles.toLocaleString()}
                  </Typography>F
                </>
              )}
              {isLoadingProcessing && (
                <Typography variant="h6">Carregando...</Typography>
              )}
            </Box>
          </CardContent>
        </Card>
      </Box>
    </LayoutBaseDePagina>
  );
};